import { Button, Checkbox, Input, Radio, RadioChangeEvent } from 'antd';
import RadioBtn from '../../Common/Form/RadioBtn';
import { _FORM_ITEM_LAYOUT, _TAIL_FORM_ITEM_LAYOUT } from '../../../constants';
import { BloodlineDiseasesWrapper, FormItemsWrapper, StyledForm } from './style';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { AddMoreBtnContainer } from '../../Common/Button/style';

const familyMembersOptions = [
  { id: '1', name: 'mother' },
  { id: '2', name: 'father' },
  { id: '3', name: 'brother' },
  { id: '4', name: 'sister' },
  { id: '5', name: `grandfather (father's side)` },
  { id: '6', name: `grandfather (maternal side)` },
  { id: '7', name: `grandmother (father's side)` },
  { id: '8', name: `grandmother (maternal side)` },
  { id: '9', name: `uncle / aunt (father's side)` },
  { id: '10', name: `uncle / aunt (maternal side)` },
];

const BloodlineDiseasesForm = () => {
  const [form] = StyledForm.useForm();
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  const [withBloodlineDiseases, setWithBloodlineDiseases] = useState<boolean>(Boolean(selectedClient?.surgeries) ?? false);
  const [selectedFamilyMembers, setSelectedFamilyMembers] = useState<Record<string, boolean>>({});
  const onFinish = (values: any) => {
    console.log('Received values of form: ', values);
  };

  const onChangeWithBloodlineDiseases = ({ target: { value } }: RadioChangeEvent) => {
    if (!value) {
      // form.setFieldValue('_destroy', true);
    }
    setWithBloodlineDiseases(value);
  };

  const onRemoveSurgery = (fieldIndex: any) => {
    const oldBloodlineDisease = form.getFieldValue('bloodlineDiseases') || [];
    const newBloodlineDisease = oldBloodlineDisease.map((item: any, index: number) =>
      index === fieldIndex ? { ...item, _destroy: true } : item
    );
    form.setFieldsValue({ bloodlineDiseases: newBloodlineDisease });
  };

  const handleBloodlineDiseasesFamilyMemberSelection = (bloodlineDiseasesFamMember: string, checked: boolean) => {
    setSelectedFamilyMembers((prev) => ({
      ...prev,
      [bloodlineDiseasesFamMember]: checked,
    }));
  };

  return (
    <StyledForm
      {..._FORM_ITEM_LAYOUT}
      form={form}
      name="bloodline_diseases_form"
      onFinish={onFinish}
      initialValues={{ residence: ['zhejiang', 'hangzhou', 'xihu'], prefix: '86' }}
      style={{ marginTop: '1rem' }}
      scrollToFirstError
    >
      <p>In my family bloodline there are specific diseases</p>
      <Radio.Group
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
        onChange={onChangeWithBloodlineDiseases}
        value={withBloodlineDiseases}
        optionType="button"
        buttonStyle="solid"
      />
      {withBloodlineDiseases && (
        <FormItemsWrapper>
          <StyledForm.List name="bloodlineDiseases">
            {(fields, { add, remove }) => (
              <>
                {fields
                  .filter(({ name }) => {
                    const bloodlineDiseases = form.getFieldValue('bloodlineDiseases') || [];
                    const fieldData = bloodlineDiseases[name];
                    return !fieldData?._destroy;
                  })
                  .map((field: any, index: number) => (
                    <BloodlineDiseasesWrapper>
                      <div className="number-container">
                        <p>{`${++index})`}</p>
                        <Button
                          size="small"
                          onClick={() => {
                            // remove(field.name);
                            onRemoveSurgery(field.name);
                          }}
                        >
                          Remove
                        </Button>
                      </div>
                      <StyledForm.Item
                        name={[field.name, 'whichDisease']}
                        label="Which disease?"
                        labelAlign="left"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field!',
                          },
                        ]}
                      >
                        <Input />
                      </StyledForm.Item>
                      <label>At which family member?</label>
                      {familyMembersOptions.map((familyMember) => (
                        <div key={familyMember.id} style={{ marginBottom: '1rem' }}>
                          <Checkbox
                            onChange={(e) => handleBloodlineDiseasesFamilyMemberSelection(familyMember.id, e.target.checked)}
                            style={{ marginBottom: '0.5rem' }}
                          >
                            {familyMember.name}
                          </Checkbox>
                          {selectedFamilyMembers[familyMember.id] && (
                            <div>
                              <StyledForm.Item
                                name={[field.name, "familyMembers", "familyMemberKey"]}
                                initialValue={familyMember.name}
                                hidden
                              >
                                <Input />
                              </StyledForm.Item>
                              <StyledForm.Item
                                name={[field.name, "familyMembers", "death", "age"]}
                                label="At which age?"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please specify at which age',
                                  },
                                ]}
                              >
                                <Input />
                              </StyledForm.Item>
                              <StyledForm.Item
                                name={[field.name, `familyMembers`, "death", "cause"]}
                                label="What was the cause?"
                              >
                                <Input />
                              </StyledForm.Item>
                            </div>
                          )}
                        </div>
                      ))}
                    </BloodlineDiseasesWrapper>
                  ))}
                <AddMoreBtnContainer>
                  <Button
                    size="small"
                    onClick={() => add()}
                  >
                    Add more
                  </Button>
                </AddMoreBtnContainer>
              </>
            )}
          </StyledForm.List>
        </FormItemsWrapper>
      )}
      <StyledForm.Item {..._TAIL_FORM_ITEM_LAYOUT}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </StyledForm.Item>
    </StyledForm>
  )
}

export default BloodlineDiseasesForm;